import { gsap } from 'gsap';

export default class Menu {
	constructor(header) {
		this.menu = header.querySelector('[data-diganl-menu]');
		this.menuBg = header.querySelector('[data-diganl-menu-bg]');
		this.menuToggle = header.querySelector('[data-diganl-menu-toggle]');
		this.nav = header.querySelector('[data-diganl-nav]');
		this.navItems = header.querySelectorAll('[data-diganl-nav-item]');

		this.breakpoint = window.matchMedia('(min-width: 992px)');

		this.isOpen = false;
		this.trapFocus = this.trapFocus.bind(this);

		if (this.menu) {
			this.init();
		}

		this.setActiveItem();

		this.menuToggle.addEventListener('click', () => {
			if (this.isOpen) {
				this.close();
			} else {
				this.open();
			}
		});
	}

	getNavLinks() {
		return Array.from(this.nav.querySelectorAll('a[href], button'));
	}

	setNavTabIndex(value) {
		this.getNavLinks().forEach((el) => {
			if (value === null) {
				el.removeAttribute('tabindex');
			} else {
				el.setAttribute('tabindex', String(value));
			}
		});
	}

	trapFocus(e) {
		if (e.key !== 'Tab') return;

		const focusable = [this.menuToggle, ...this.getNavLinks()];
		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === first) {
				e.preventDefault();
				last.focus();
			}
		} else {
			if (document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		}
	}

	setActiveItem() {
		const currentPath = window.location.pathname + window.location.hash;

		this.navItems.forEach((item) => {
			const link = item.querySelector('a');
			if (!link) return;

			const linkUrl = new URL(link.href, window.location.origin);
			const linkPath = linkUrl.pathname + linkUrl.hash;
			if (linkPath === currentPath) {
				item.classList.add('is-active');
			}
		});
	}

	init() {
		if (!this.breakpoint.matches) {
			this.initialState();
		}

		this.breakpoint.addEventListener('change', (e) => {
			if (e.matches) {
				this.reset();
			} else {
				this.initialState();
			}
		});
	}

	initialState() {
		gsap.set(this.menuBg, { opacity: 0, pointerEvents: 'none' });
		gsap.set(this.nav, { opacity: 0, y: -20, height: 0, overflow: 'hidden' });
		this.setNavTabIndex('-1');
	}

	open() {
		this.menu.classList.add('is-open');
		this.menuToggle.setAttribute('aria-expanded', 'true');

		gsap.to(this.menuBg, {
			duration: 0.3,
			opacity: 1,
			pointerEvents: 'auto',
		});

		gsap.fromTo(
			this.nav,
			{ opacity: 0, y: -20, height: 0 },
			{ duration: 0.3, opacity: 1, y: 0, height: 'auto', delay: 0.1 }
		);

		this.setNavTabIndex('0');
		document.addEventListener('keydown', this.trapFocus);

		this.isOpen = true;
	}

	reset() {
		this.menu.classList.remove('is-open');
		this.menuToggle.setAttribute('aria-expanded', 'false');
		gsap.set(this.menuBg, { opacity: 0, pointerEvents: 'none' });
		gsap.set(this.nav, { opacity: 1, y: 0, height: 'auto', overflow: '' });
		this.setNavTabIndex(null);
		document.removeEventListener('keydown', this.trapFocus);
		this.isOpen = false;
	}

	close() {
		this.menu.classList.remove('is-open');
		this.menuToggle.setAttribute('aria-expanded', 'false');

		gsap.to(this.menuBg, {
			duration: 0.3,
			opacity: 0,
			pointerEvents: 'none',
		});

		gsap.to(this.nav, { duration: 0.3, opacity: 0, y: -20, height: 0 });

		this.setNavTabIndex('-1');
		document.removeEventListener('keydown', this._trapFocus);

		this.isOpen = false;
	}
}
